import { atom } from "jotai";
import type { Post } from "#/lib/api/posts";

/**
 * learn 글 페이지가 fetch 결과를 게시하는 SEO 심(seam).
 * head 기록자는 SeoSync 단일 유지 — 글 페이지는 여기에 쓰기만 하고,
 * SeoSync가 구독해 syncDocumentSeo로 전달한다.
 * `{ slug, post: null }` = 404(noindex 분기), atom 전체 null = 로딩/비-learn 경로.
 */
export const learnSeoAtom = atom<{ slug: string; post: Post | null } | null>(
	null,
);
